/* eslint-disable @typescript-eslint/unbound-method */
/* eslint-disable @typescript-eslint/no-unsafe-argument */

import { CommonApi } from "../clients";
import { wrap } from "../wrap";

const commonApi = {
  getCsrfCookie: wrap(CommonApi, CommonApi.prototype.getCsrfCookie),
};

export default commonApi;
